import { Card, Grid } from '@mui/material';
import PageTitleWrapper from './PageTitleWrapper';
import PageHeader from './PageHeader'


const ComponentEdit = ({ children, title, subtitle, actions = null }) => (
  <>
    <PageTitleWrapper>
      <PageHeader title={title} subtitle={subtitle} actions={actions} />
    </PageTitleWrapper>
    <Grid
      sx={{
        px: 4,
      }}
      container
      direction="row"
      justifyContent="center"
      alignItems="stretch"
      spacing={4}
    >
      <Grid item xs={12} >
        {/* Pages bring their own Card: it sits flush inside this frame instead of drawing a second one.
            Nothing is clipped, so a sticky form toolbar can follow the scroll. */}
        <Card sx={{ overflow: "visible", "& > .MuiCard-root": { border: "0 !important", borderRadius: "inherit !important" } }}>
          {children}
        </Card>
      </Grid>
    </Grid>
  </>
);



export default ComponentEdit;